<input type="checkbox" id="toggle-button-checkbox"
(change)="changed.emit($event.target.checked)">
<label class="toggle-button-switch"  
for="toggle-button-checkbox"></label>
<div class="toggle-button-text">
<div class="toggle-button-text-on">Active</div>
<div class="toggle-button-text-off">Inactive</div>
</div>
